export const submenuKeysList = [
  'workforce-management-submenu',
  'resources-submenu',
  'messaging-submenu',
  'employee-payments-submenu',
  'contractor-payments-submenu',
  'reports-submenu',
  'company-submenu'
]

export function createLayoutTourSteps(beforeStart) {
  return [
    // Workflow
    {
      target: '#associate-shifts-tab',
      header: {
        title: 'Shifts'
      },
      params: {
        placement: 'right'
      },
      before: beforeStart,
      content:
        'In Shifts section you can review the shifts that your associates have worked. This allows you to track attendance and monitor work patterns effectively.'
    },
    {
      target: '#associate-auths-tab',
      header: {
        title: 'Violations'
      },
      params: {
        placement: 'right'
      },
      content:
        'In the Violations section, you can review actions taken by your associates that may contradict company policies. This helps you manage and address rule violations.'
    },
    {
      target: '#associate-pc-tab',
      header: {
        title: 'Pay Codes'
      },
      params: {
        placement: 'right'
      },
      content:
        'In the Pay Codes section, you can create shifts using Pay Codes. This is useful for keeping track of days when your associates are not working, such as vacations or sick days.'
    },
    {
      target: '#associate-activity-tab',
      header: {
        title: 'Activity'
      },
      params: {
        placement: 'right'
      },
      content:
        'The Activity section is used to monitor the current activities of associates. You can see who is working, who has left, and other real-time status updates of your team.'
    },
    {
      target: '#associate-time-off-tab',
      header: {
        title: 'Time Off Requests'
      },
      params: {
        placement: 'right'
      },
      content:
        'The Time Off Requests section allows you to review requests for time off from your associates. This helps you manage and approve or deny requests efficiently.'
    },
    {
      target: '#reports-daily-summary-tab',
      header: {
        title: 'Daily Summary'
      },
      params: {
        placement: 'right'
      },
      content:
        "The Daily Summary report is crucial for understanding the day's operations. It provides key metrics, created and completed shifts, and offers a snapshot of the company's performance for the day. Reviewing this daily helps track the company's progress and identify trends."
    },

    // Resources
    {
      target: '#associate-profiles-tab',
      header: {
        title: 'Profiles'
      },
      params: {
        placement: 'right'
      },
      content:
        'The Profiles section contains information about your associates. You can view and manage associate details to ensure your records are up-to-date.'
    },
    {
      target: '#documents-store-tab',
      header: {
        title: 'Documents Library'
      },
      params: {
        placement: 'right'
      },
      content: 'In the Documents Library section, you can manage all documents.'
    },

    // Message
    {
      target: '#notification-notif-tab',
      header: {
        title: 'Send Notification'
      },
      params: {
        placement: 'right'
      },
      content:
        'The Send Notification section allows you to send important notifications to anyone in the company. Use this to keep your team informed about crucial updates and messages.'
    },

    // Payments
    {
      target: '#payment-request-tab',
      header: {
        title: 'Invoices'
      },
      params: {
        placement: 'right'
      },
      content: 'In the Invoices section, you can manage all invoices.'
    },

    // Reports
    {
      target: '#reports-time-attendance-tab',
      header: {
        title: 'Time / Attendance Detail'
      },
      params: {
        placement: 'right'
      },
      content:
        'The Time / Attendance Detail report is essential for recording worked shifts. It allows you to export reports for a specific date range, detailing the work of individual associates. This report is often used for official records and internal audits.'
    },
    {
      target: '#reports-total-hours-tab',
      header: {
        title: 'Total Hours Detail'
      },
      params: {
        placement: 'right'
      },
      content:
        'The Total Hours Detail Record shows the total hours worked by associates over a selected period. It includes filtering options to customize the report as needed.'
    },
    {
      target: '#reports-signed-shifts-tab',
      header: {
        title: 'Signed Shifts'
      },
      params: {
        placement: 'right'
      },
      content:
        'The Signed Shifts report displays all the shifts that have been signed off by associates within a specific period. It helps ensure that all worked shifts are properly documented and reviewed.'
    },
    {
      target: '#reports-not-in-work-area-tab',
      header: {
        title: 'Not in Work Area'
      },
      params: {
        placement: 'right'
      },
      content:
        'The Not in Work Area report tracks actions taken by associates outside their assigned work areas. This is important for identifying unauthorized activities and ensuring compliance with company policies.'
    },
    {
      target: '#reports-associate-tab',
      header: {
        title: 'Associate'
      },
      params: {
        placement: 'right'
      },
      content:
        'The Associate report provides detailed information about current associates, including their profiles and statuses. It is useful for maintaining up-to-date records on all associates.'
    },
    {
      target: '#reports-overtime-tab',
      header: {
        title: 'Overtime'
      },
      params: {
        placement: 'right'
      },
      content:
        'The Overtime report tracks the amount of overtime worked by associates. It categorizes overtime into regular overtime (8 to 12 hours) and extended overtime (12 to 16 hours), helping to monitor labor costs and associate workload.'
    },
    {
      target: '#reports-mispunch-tab',
      header: {
        title: 'Mispunch'
      },
      params: {
        placement: 'right'
      },
      content:
        'The Mispunch Report identifies discrepancies in shift records, such as missed clock-ins or clock-outs. This helps ensure accurate time tracking and payroll processing.'
    },
    {
      target: '#reports-worked-shifts-tab',
      header: {
        title: 'Worked Shifts'
      },
      params: {
        placement: 'right'
      },
      content: 'The Worked Shifts Report shows the number of whole shifts worked by day for a date range'
    },
    {
      target: '#reports-pbj-tab',
      header: {
        title: 'PBJ Report'
      },
      params: {
        placement: 'right'
      },
      content:
        'The PBJ Report is used for generating reports required for Payroll Based Journal submissions. It compiles all necessary information for regulatory compliance.'
    },

    // Settings
    {
      target: '#company-info-tab',
      header: {
        title: 'Information'
      },
      params: {
        placement: 'right'
      },
      content:
        "In the Company Info section you can find comprehensive information about your company, including statistics and key metrics that give you an overview of the company's performance."
    },
    {
      target: '#company-role-tab',
      header: {
        title: 'Positions'
      },
      params: {
        placement: 'right'
      },
      content:
        'In the Positions section, you can set up different positions in your company. This includes defining the privileges associated with each position to ensure proper role-based access and responsibilities.'
    },
    {
      target: '#legal-entity-tab',
      header: {
        title: 'Legal Entity'
      },
      params: {
        placement: 'right'
      },
      content:
        'In the Legal Entity section, you can specify the companies or agencies you work with that provide you with workers. Additionally, you can list companies for Sole Proprietors, ensuring all your external workforce sources are properly documented.'
    },
    {
      target: '#company-pc-tab',
      header: {
        title: 'Pay Codes'
      },
      params: {
        placement: 'right'
      },
      content:
        'The Pay Codes section allows you to set up codes for different types of pay. For instance, you can use PayCodes to pay an associate for a vacation day or a sick day. This helps in accurately tracking and managing different pay scenarios.'
    },
    {
      target: '#payment-settings-tab',
      header: {
        title: 'Payment Settings'
      },
      params: {
        placement: 'right'
      },
      content: 'In the "Payment Settings" section, you can configure the settings for all invoices.'
    }
  ]
}
